module.exports = __webpack_public_path__ + "static/media/brief_banner2x.ab34c9ca.jpg";